import { formatStripePrice } from '@/common/utils';
import { Box, Flex, Text } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { HeaderImage } from './header-image';
import styles from './styles.module.css';

type BaseSubscriptionProps = {
	price: number;
	perPeriod: string;
	name: string;
	subtitle1: string | null | undefined;
	subtitle2: string | null | undefined;
	bullets: string[] | null | undefined;
	buttons: ReactNode[];
	color: string;
};

export const SubscriptionCard = ({
	price,
	perPeriod,
	name,
	subtitle1,
	subtitle2,
	bullets,
	buttons,
	color,
}: BaseSubscriptionProps) => (
	<Flex
		direction="column"
		gap="md"
		justify="space-between"
		align="center"
		flex={1}
		maw={410}
		ml="auto"
		mr="auto"
		className={styles.container}
	>
		<Flex
			pos="relative"
			direction="column"
			justify="flex-start"
			align="center"
			flex={1}
			className={styles.header}
		>
			<HeaderImage color={color} />
			<Flex direction="column" m="lg" gap={25} align="center">
				<Text c={color ? 'white' : undefined} fw={900} fz="20px" className={styles.headerText}>
					{formatStripePrice(price)} / {perPeriod}
				</Text>
				<Text fw={900} fz="36px" className={styles.headerText}>
					{name}
				</Text>
			</Flex>
		</Flex>
		<Flex
			direction="column"
			justify="center"
			align="stretch"
			flex={1}
			px="lg"
			pb="xl"
			w="100%"
			gap="md"
		>
			{(!!subtitle1 || !!subtitle2) && (
				<Flex
					direction="column"
					justify="center"
					align="center"
					flex={1}
					className={styles.subheader}
					px="16px"
					py="8px"
				>
					<Text className={styles.subheaderText}>{subtitle1}</Text>
					<Text className={styles.subheaderText}>{subtitle2}</Text>
				</Flex>
			)}
			{!!bullets?.length && (
				<Box w="100%">
					{bullets?.map((bullet, ix) => (
						<Flex key={ix} align="flex-start" gap="xs">
							<Box>
								<IconCircleCheck size={32} />
							</Box>
							<Text className={styles.bulletText}>{bullet}</Text>
						</Flex>
					))}
				</Box>
			)}
			{buttons}
		</Flex>
	</Flex>
);
